import { render, staticRenderFns } from "./BrandEprEdit.vue?vue&type=template&id=cef2f8cc&"
import script from "./BrandEprEdit.vue?vue&type=script&lang=js&"
export * from "./BrandEprEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrandEprEdit.vue?vue&type=style&index=0&id=cef2f8cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports